import { useState } from "react";

function useCopyWithAlert(alertDuration = 5000) {
  const [alertVisibility, setAlertVisibility] = useState(false);

  const handleCopy = (value: string) => {
    navigator.clipboard.writeText(value);
    setAlertVisibility(true);
    setTimeout(() => {
      setAlertVisibility(false);
    }, alertDuration);
  };

  return { alertVisibility, handleCopy };
}
export default useCopyWithAlert;
